import { useQuery } from "@tanstack/react-query";
import {  useCallback,  useLayoutEffect,  useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { IoMdArrowRoundBack } from "react-icons/io";
import { ApiList } from "../../../Api/ApiList";
import { fetch_data_from_api_from_query } from "../../../Api/APICalls";
import ListGroup from "react-bootstrap/ListGroup";
import { get_bool_value } from "../../../utils";
import NoProduct from "../../NoProduct/NoProduct";
import InvestorPDFCard from "../investor-pdf-card/investor-pdf-card";
import { get_property_settings } from "../../Helper";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../Loader";
import "./InvestorModal.css";

function InvestorModal() {
  const [open_investor_modal, set_open_investor_modal] = useState(false);
  const navigate = useNavigate()
  
  const [searchParams] = useSearchParams()
  const initial_investor_id = searchParams.get("investor_id")
  const [investor_id, set_investor_id] = useState(null)
  const [titles, set_titles] = useState(["Investor"])
  let show_investor_module_frontend = get_property_settings("show_investor_module_frontend")
    show_investor_module_frontend = get_bool_value(show_investor_module_frontend)
  
  const {data} = useQuery({
      queryKey: [ApiList.Investor],
      queryFn: () => fetch_data_from_api_from_query(ApiList.Investor, ApiList.Investor, {}),
      initialData: [],
      enabled: !!show_investor_module_frontend,
    })
    
    useLayoutEffect(() => {
      if(!initial_investor_id || !data?.length) return 
      set_investor_id(initial_investor_id)
      set_open_investor_modal(true)
    }, [initial_investor_id, data])
    
   

  const FindList = useCallback((InvestorData, investor_id) => {
    if(!Array.isArray(InvestorData)) return null;
    if(investor_id === "0") return data
    return InvestorData?.reduce((result, currentItem) => {
      if (result) return result;
      if (currentItem.id === investor_id) return currentItem;
      if (currentItem?.subcategory)
        return FindList(currentItem?.subcategory, investor_id);
    }, null);
  }, [data])

  const investor_list_data = useMemo(() => {
    if (!investor_id || !data) return null;
    const investor_data = FindList(data, investor_id)
  
    let subcategory = investor_id === "0" ? investor_data : investor_data?.subcategory;
    
    if (!!subcategory && Array.isArray(subcategory) && subcategory.length > 0) {
    
      return subcategory;
    } else if (Array.isArray(subcategory) && subcategory.length === 0) {
      
      set_investor_id(investor_data?.cat_parent_id)
      navigate("/investor", {state: {selected_module: investor_data, titles: titles}})
      return ;
      // return investor_id;
    } else {
   
      return null;
    }
  }, [investor_id, data]);

  

  const pdf_list_query = useQuery({
    queryKey: [ApiList.Investor_get_document, investor_list_data],
    queryFn: () =>
      fetch_data_from_api_from_query(
        ApiList.Investor_get_document,
        ApiList.Investor_get_document,
        { cat_id: investor_list_data }
      ),
    enabled: typeof investor_list_data === "string",
  });

  const handle_close_modal = () => {
    navigate("/home")
    set_titles([])
    set_open_investor_modal(false)
  }


  const handle_back_arrow = () => {
     if(!investor_id) return
     const list = FindList(data, investor_id)
     const cat_parent_id = list?.cat_parent_id
     if(investor_id === "0"){
       set_titles([])
       handle_close_modal()
      }else{
       set_titles(pre => pre.filter(title => title !== list?.title))
      
     }
     
     set_investor_id(cat_parent_id || "0")
  }
  

  const Modal_Title = useMemo(() => {
    if(!investor_id) return "Investor"
    const title = FindList(data, investor_id)?.title || "Investor"
    set_titles(prev => [...new Set([...prev, title])])
    return title
  }, [investor_id])

 
  return (
    <Modal
      show={open_investor_modal}
      className="categoryModal"
      onHide={handle_close_modal}
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg d-flex align-items-center">
         <IoMdArrowRoundBack onClick={handle_back_arrow}/>
          <span>{Modal_Title}</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        { typeof investor_list_data === "string" && pdf_list_query.isLoading ? (
          <Loader isLoading={true}/>
        ) :
        
        typeof investor_list_data === "string" &&
        !!pdf_list_query.data && Array.isArray(pdf_list_query.data) && !!pdf_list_query.data.length ? (
            <InvestorPDFCard pdf_data={pdf_list_query.data}/>
        ) : typeof investor_list_data === "string" && (!pdf_list_query.data || !pdf_list_query.data?.length) ? (
          <NoProduct errMsg={"No data found"} hideHomeBtn={true}  hideCartImg={true}/>
        ) : Array.isArray(investor_list_data) && !!investor_list_data.length ? (
          <ListGroup>{
            investor_list_data.map(investor_list => {
              const handle_list = () => {
                set_investor_id(investor_list?.id)
              }
              return <ListGroup.Item key={investor_list?.id} onClick={handle_list} className="investor-modal-list">{investor_list?.title}</ListGroup.Item>
            })
            }</ListGroup>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}

export default InvestorModal;
